var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3334 22.7497V14.733C43.3334 11.0927 43.3334 9.2725 42.625 7.88207C42.0018 6.65902 41.0074 5.66464 39.7844 5.04147C38.3939 4.33301 36.5738 4.33301 32.9334 4.33301H19.0667C15.4264 4.33301 13.6062 4.33301 12.2158 5.04147C10.9928 5.66464 9.99838 6.65902 9.37521 7.88207C8.66675 9.2725 8.66675 11.0927 8.66675 14.733V37.2663C8.66675 40.9067 8.66675 42.7269 9.37521 44.1173C9.99838 45.3403 10.9928 46.3347 12.2158 46.9579C13.6062 47.6663 15.4264 47.6663 19.0667 47.6663H26.0001",
    stroke: "#02698C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3333 23.8337H17.3333M21.6666 32.5003H17.3333M34.6666 15.167H17.3333M38.9999 45.5003V32.5003M32.4999 39.0003H45.4999",
    stroke: "#02698C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilePlus);
export default __webpack_public_path__ + "static/media/IconFilePlus.3a4ace43598877929dacea0735b80f00.svg";
export { ForwardRef as ReactComponent };